import React from 'react';
import { Route, Redirect, RouteProps } from 'react-router-dom';
import { isLogin } from '../helpers';

export const PrivateRoute: React.FC<RouteProps> = ({ children, ...rest }) => {
  return (
    <Route {...rest}>{isLogin() ? children : <Redirect to="/login" />}</Route>
  );
};
